import { render } from "./NewsView.vue?vue&type=template&id=63dcbba1&scoped=true"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"

import "./NewsView.vue?vue&type=style&index=0&id=63dcbba1&lang=scss"
import "./NewsView.vue?vue&type=style&index=1&id=63dcbba1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dcbba1"]])

export default __exports__